import { useEffect, useState } from 'react';

import { InjectReducerArgs } from '../utils/injectReducer';
import { InjectSagaArgs } from '../utils/injectSaga';

import useInjectReducer from './useInjectReducer';
import useInjectSaga from './useInjectSaga';

interface InjectArgs extends InjectSagaArgs, InjectReducerArgs {
  saga: any;
}

const useInject = ({ key, reducer, saga, mode }: InjectArgs) => {
  const [ready, setReady] = useState(false);

  useInjectReducer({ key, reducer });
  useInjectSaga({ key, saga, mode });

  // Using effect to ensure that the reducer is injected before returning `ready`
  useEffect(() => {
    setReady(true);
  }, []);

  return ready;
};

export default useInject;
